import React, { useEffect, useState } from 'react';

// MUI
import { Alert, Grid, Skeleton, Box } from '@mui/material';

// Icons
import { ErrorRounded } from '@mui/icons-material';

// Util
import config from '../../config';
import { Link } from 'react-router-dom';
import { send_request } from '../../utils/Request';
import NonFormTriggerSkeleton from './NonFormTriggers/NonFormTriggerSkeleton';

// Styles
import './TestPanel.css';

const TestIframeRender = props => {
  // Initial call
  useEffect(() => {
    const triggerGetTests = async () => {
      await getTests();
    };
    triggerGetTests();
  }, []);

  useEffect(() => {
    const handleRefresh = async () => {
      if (!props.refresh) return; // If not refreshing, return

      props.setTests([]);
      // Handle refresh logic
      await getTests();

      props.setRefresh(false);
      props.setLoadingInputPHs(false);
    };
    handleRefresh();
  }, [props.refresh]);

  const getTests = async () => {
    return await send_request(
      `project-service/test/get_tests/${props.projectId}`,
      '',
      '',
      'GET'
    ).then(async res => {
      // Creates a test if there is none
      if (res.data.length === 0) {
        await send_request(
          `project-service/test/create_test/${props.projectId}`,
          {
            name: 'Test',
          },
          '',
          'POST'
        ).then(res => {
          props.setTests([res.data]);
        });
      } else {
        props.setTests(res.data);
      }
    });
  };

  const renderComponent = (componentId, type, componentData = null, projectId, version) => {
    let src =
      config.FORM.FORM_FRONT_END + `/form/form_test/` + componentId + `/${props.tests[0].testId}`;

    if (props.tests.length > 0 && props.tests[0].testSessions !== null) {
      const testSessions = props.tests[0].testSessions;
      const sessionId = testSessions[componentId];
      if (sessionId !== undefined) {
        src += `/${sessionId}`;
      }
    }

    let name = 'Untitled';

    if (componentData) {
      name = componentData.label;
    }

    src += '?isLatestDraft=true';

    switch (type) {
      case 'form':
      case 'bulk_assessment':
        return (
          <div className="browser-wrapper">
            <div className="browser-bar">
              <div className="browser-dots">
                <div className="browser-dot browser-dot-red"></div>
                <div className="browser-dot browser-dot-yellow"></div>
                <div className="browser-dot browser-dot-green"></div>
              </div>
            </div>
            <iframe
              className="browser-iframe"
              src={
                type === 'form'
                  ? src
                  : `${config.FORM.FORM_FRONT_END}/bulk/bulk_test/${componentId}/${props.tests[0].testId}?test=true`
              }
              onLoad={props.loadingInputPHs ? props.setLoadingInputPHs(false) : null}
            />
          </div>
        );
      case 'trigger_from_a_workflow':
      case 'schedule_start':
      case 'webhook':
        if (props.loadingInputPHs) props.setLoadingInputPHs(false);
        return (
          <NonFormTriggerSkeleton
            componentType={type}
            componentId={componentId}
            componentName={name}
            projectId={projectId}
            projectVersion={version}
            testId={props.tests[0].testId}
            testValues={
              props.tests[0].testValues !== null && props.tests[0].testValues !== undefined
                ? props.tests[0].testValues[componentId]
                : []
            }
          />
        );
    }
  };

  return (
    <div
      style={{
        padding: props.expanded ? '16px 0px 0px 0px' : '0px',
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
      }}
    >
      <Grid container direction="column" spacing={0} sx={{ flex: 1, minHeight: 0, width: '100%' }}>
        {!props.isTestPane && (
          <Grid item xs={12} sx={{ marginBottom: '12px', flexShrink: 0 }}>
            <Alert className="test-alert" icon={<ErrorRounded className="test-alert-icon" />}>
              After submitting a test trigger, go to the{' '}
              <Link
                className="test-alert-link"
                to={`/project/logs/${props.projectId}?test=true`}
                target="_blank"
              >
                test session logs
              </Link>{' '}
              to track the test session
            </Alert>
          </Grid>
        )}
        <Grid item xs={12} sx={{ margin: 0, padding: 0, flexShrink: 0 }}>
          {props.loadingInputPHs && (
            <Skeleton className="test-skeleton" variant="rectangular" width="100%" height={250} />
          )}
        </Grid>
        <Grid item xs={12} sx={{ margin: 0, padding: 0 }}>
          {!props.loadingInputPHs &&
            props.tests.length > 0 &&
            renderComponent(
              props.componentId,
              props.expanded ? props.compData.type : props.compData.data.type,
              props.compData.data,
              props.projectId,
              props.version
            )}
        </Grid>
      </Grid>
    </div>
  );
};

export default TestIframeRender;
